<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
} from "@/editor/EditComponentStatic";
const emitFn = defineEmits<CommonEditControlEmits>();

const props = defineProps<EditControlProps>();
const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
var uiData = reactive(ui);

onMounted(() => {
  mounted(uiData, props, config);
});
</script>
<template>
  <div class="wrap" v-if="uiData.showMutable">
    <h3 class="blue--text py-2">{{ uiData.data ?? uiData.title }}</h3>
  </div>
</template>

